import { default as LinkNext } from "next/link";
import type { ReactNode } from "react";

import { classNames } from "@/utils/styling-utils";
import { Heading } from "../base/heading";
import { VerticalSpacer } from "../layout/vertical-spacer";
import { AlertBubble } from "./alert-bubble";
/**
 * Use LinkCard if you want a clickable card with routing (href)
 */
interface LinkCardProps {
  alert?: number;
  bgColor?: "blue" | "neutral"; // blue er default
  bigOnDesktop?: boolean;
  children?: ReactNode;
  heading?: ReactNode;
  href: string;
  onClick?: () => void;
}

export const LinkCard = ({ alert, bgColor, bigOnDesktop, children, heading, href, onClick }: LinkCardProps) => {
  const showAlert = alert !== undefined && alert > 0;

  return (
    <LinkNext
      className={classNames(
        "link-card",
        bgColor && `link-card__background-color--${bgColor}`,
        bigOnDesktop && "link-card--big-on-desktop",
        children !== undefined && "link-card--has-children",
        showAlert && "link-card--alert", // ikke implementert i css
      )}
      href={onClick ? "" : href}
      onClick={onClick}
    >
      {heading && (
        <Heading type="h2">
          {heading}
          {showAlert && (
            <>
              <VerticalSpacer size="xx-small" />
              <AlertBubble alert={alert} raised={true} />
            </>
          )}
        </Heading>
      )}
      {children}
    </LinkNext>
  );
};

export const LinkCardPlaceholder = () => <div className={classNames("link-card")} role="presentation" />;
